function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Controles de Sele\xE7\xE3o");

var SvgSelectors = function SvgSelectors(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M83.17,40.58H66.8a7.42,7.42,0,1,0,0,14.84H83.17a7.42,7.42,0,0,0,0-14.84ZM66.8,54.09A6.09,6.09,0,1,1,72.89,48,6.11,6.11,0,0,1,66.8,54.09Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M43.58,40.58A7.42,7.42,0,1,0,51,48,7.43,7.43,0,0,0,43.58,40.58Zm0,11.84a4.56,4.56,0,1,1,4.56-4.56A4.57,4.57,0,0,1,43.58,52.42Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M25.75,40.58H15a2,2,0,0,0-2,2V53.38a2,2,0,0,0,2,2H25.75a2,2,0,0,0,2-2V42.62A2,2,0,0,0,25.75,40.58Zm-1,6.41-4.35,4.35-.82.82a.58.58,0,0,1-.82,0L18,51.34l-2.17-2.17a.58.58,0,0,1,0-.82l.82-.82a.54.54,0,0,1,.4-.16.56.56,0,0,1,.41.16l1.77,1.78,3.94-4a.58.58,0,0,1,.41-.17.57.57,0,0,1,.41.17l.82.82a.54.54,0,0,1,.17.4A.57.57,0,0,1,24.79,47Z",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSelectors, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SELECTORS.74f4e174.svg";
export { ForwardRef as ReactComponent };